import API from "../../../hooks/api";
import {
  RELATED_PARTIES_URL,
  RELATED_PARTIES_STATUS_UPDATE,
  getFullURL,
  RELATED_PARTIES_DETAILS,
} from "../../../utils/Endpoints";
import { RelatedPartiesList, filters } from "./ScreenHelper";
import { showDetailsTable } from "./ScreenHelper";

export const getRelatedParties = async (
  data: filters,
  callBack: (
    success: boolean,
    data: RelatedPartiesList,
    errorMsg: string | null
  ) => void = () => {}
) => {
  const paramsObj = getParamObj(data);
  await API.get(getFullURL(RELATED_PARTIES_URL), { params: paramsObj })
    .then((res) => {
      const data: RelatedPartiesList = res.data;
      callBack(true, data, null);
      return res.data;
    })
    .catch((err) => {
      callBack(false, null, err);
    });
};

export const getRelatedPartiesDetails = async (
  t,
  data,
  callBack: (success: boolean, errorMsg: string | null) => void = () => {}
) => {
  await API.get(RELATED_PARTIES_DETAILS + data.financialDataId)
    .then((res) => {
      showDetailsTable(t, res.data.details, false);
    })
    .catch((err) => {
      callBack(false, err);
    });
};

export const getRelatedPartiesStatusUpdate = async (
  data,
  callBack: (success: boolean, errorMsg: string | null) => void = () => {}
) => {
  await API.put(getFullURL(RELATED_PARTIES_STATUS_UPDATE), data)
    .then((res) => {
      callBack(true, "Data updated successfully");
      return res.data;
    })
    .catch((err) => {
      callBack(false, err);
    });
};

function getParamObj(data: filters) {
  let payload = {
    page: data.page ?? 1,
    size: data.size ?? 10,
    searchText: data.searchText ?? "",
    loadAllDocuments: data.loadAllDocuments ?? false,
    status: data.status ?? "ALL",
  };

  if (data.searchText && data.searchText.trim() !== "") {
    payload["status"] = "ALL";
  }

  if (!data.loadAllDocuments) {
    payload = { ...payload, searchText: data.searchText ?? "" };
  }
  return payload;
}
